exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-item-icon {\n    display: inline-block;\n    margin: auto;\n}\n\n.item[placeholder]:empty:before {\n    content: attr(placeholder);\n    color: #555;\n}\n\n.item[placeholder]:empty:focus:before {\n    content: \"\";\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/vlad/Projects/done/web/src/app/items/NewItem.component.css
// module id = ../../../../../src/app/items/NewItem.component.css
// module chunks = main